import React, { useState, useEffect } from 'react'
import { Card, Button } from 'react-bootstrap'

function DownloadApp() {
  return (
    <div className="center-screen subscription-checkout">
      <Card style={{ width: '29rem' }}>
        <Card.Body>
          <h3 className="info-text">Success!</h3>
        </Card.Body>
      </Card>
    </div>
  )
}

export default DownloadApp
